import { useEffect } from 'react'
import { Step } from '../components'
import { useOnboarding } from '../context'
import type { InputQuestionValues } from '../typings'
import type { StepProps } from './StepProps'

const PERSONAL_USE: InputQuestionValues = {
  key: 'personal_use',
  trackingKey: 'personal',
  question: 'Please read and accept the terms and conditions'
}

export const PersonalStep = (props: StepProps) => {
  const { state, updateState } = useOnboarding()

  useEffect(() => {
    const survey = state.survey
    survey[PERSONAL_USE.key] = {
      question: PERSONAL_USE.question,
      label: 'Personal Use',
      value: true
    }

    updateState({ survey })
  }, [])
  return (
    <Step
      index={props.index}
      surveyKey={PERSONAL_USE.key}
      trackingKey={PERSONAL_USE.trackingKey}
      title={PERSONAL_USE.question}
    />
  )
}
